import { centroid } from "../../../util/turf";
import { siteGeometryStore } from "../store";

export const getSitesWhereCenterIsInBounds = (bounds: google.maps.LatLngBounds) => {
  return siteGeometryStore.siteFeatures.filter((feature) => {
    if (!feature.geometry) return false;
    const centerCoordinates = centroid(feature.geometry).geometry?.coordinates;
    if (!centerCoordinates) return false;

    return bounds.contains(new google.maps.LatLng(centerCoordinates[1], centerCoordinates[0]));
  });
};
